export default __webpack_public_path__ + "static/media/A4H501C4.b169039b.mp4";